import { createContext, useReducer, useContext } from "react";

export const AppContext = createContext();

const initialState = {
    user: {},
    users: [],
    bots: [],
    profiles: [],
    strategies: [],
    customMarkets: [],
    exchangeMarkets: [],
    logsSuccess: [],
    logsError: [],
};

export const APP_ACTIONS = {
    SET_USER: "SET_USER",
    SET_USERS: "SET_USERS",
    SET_BOTS: "SET_BOTS",
    SET_MARKETS: "SET_MARKETS",
    SET_PROFILES: "SET_PROFILES",
    SET_BOT_STRATEGIES: "SET_BOT_STRATEGIES",
    SET_CUSTOM_MARKETS: "SET_CUSTOM_MARKETS",
    SET_EDGE_CASE_ALERT: "SET_EDGE_CASE_ALERT",
    SET_BOT_LOGS_SUCCESS: "SET_BOT_LOGS_SUCCESS",
    SET_BOT_LOGS_ERROR: "SET_BOT_LOGS_ERROR",
    SET_BOT_LOGS_WARNING: "SET_BOT_LOGS_WARNING",
    SET_BOT_LOGS_CLEAR: "SET_BOT_LOGS_CLEAR",
};

const appReducer = (state, action) => {
    const { type, payload } = action;
    const updateState = (obj) => ({ ...state, ...obj });

    switch (type) {
        case APP_ACTIONS.SET_USER:
            return updateState({ user: payload });
        case APP_ACTIONS.SET_USERS:
            return updateState({ users: payload });
        case APP_ACTIONS.SET_BOTS:
            return updateState({ bots: payload });
        case APP_ACTIONS.SET_PROFILES:
            return updateState({ profiles: payload });
        case APP_ACTIONS.SET_EDGE_CASE_ALERT:
            let newBots = [...state.bots];
            let botFoundIndex = newBots.findIndex(x => x.id === payload.bot_id)
            if (botFoundIndex !== -1) {
                newBots[botFoundIndex].notificationAlert = payload.notificationAlert
            }
            return {
                ...state,
                bots: newBots
            }
        case APP_ACTIONS.SET_CUSTOM_MARKETS:
            return updateState({ customMarkets: Array.isArray(payload) && payload || [] });
        case APP_ACTIONS.SET_BOT_STRATEGIES:
            let newStrategies = [...state.strategies];
            let foundIndex = newStrategies.findIndex(x => x.id === payload.id)
            if (foundIndex !== -1) {
                newStrategies[foundIndex] = payload
            } else {
                newStrategies.push(payload)
            }

            return {
                ...state,
                strategies: newStrategies
            }
        case APP_ACTIONS.SET_MARKETS:
            let newExchangeMarkets = [...state.exchangeMarkets];
            const Index = newExchangeMarkets.findIndex(x => x.id == payload.id)

            if (Index < 0) newExchangeMarkets.push(payload);
            else {
                newExchangeMarkets.splice(Index, 1, payload);
            }
            return {
                ...state,
                exchangeMarkets: newExchangeMarkets
            }
        case APP_ACTIONS.SET_BOT_LOGS_SUCCESS:
            let newLogsSuccess = [...state.logsSuccess];
            newLogsSuccess.unshift(payload);
            return {
                ...state,
                logsSuccess: newLogsSuccess
            }
        case APP_ACTIONS.SET_BOT_LOGS_ERROR:
            let newLogsError = [...state.logsError];
            newLogsError.unshift(payload);
            return {
                ...state,
                logsError: newLogsError
            }
        case APP_ACTIONS.SET_BOT_LOGS_WARNING:
            let newLogsWarning = [...state.logsSuccess];
            newLogsWarning.unshift(payload);
            return {
                ...state,
                logsSuccess: newLogsWarning
            }
        case APP_ACTIONS.SET_BOT_LOGS_CLEAR:
            return {
                ...state,
                logsSuccess: [],
                logsError: []
            }
        default:
            return state;
    }
};

const AppContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    const context = { state, dispatch };

    return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);

export let API_URL = process.env.NODE_ENV === 'production' ? 'https://-:3005' : 'http://-:3005'
export let WS = process.env.NODE_ENV === 'production' ? 'wss://-:5005' : 'ws://-:5005'
export let HOST = '-';
export let jwtToken = null;
export let userId = null;
export let APP_VERSION = '3.16.0'

export const changeHostIP = (data) => {

    return new Promise((resolve, reject) => {
        if (data.host_ip.includes('http') || data.host_ip.includes('.com')) {
            let hostIP = !data.host_ip.includes('https') ? `https://${data.host_ip}` : data.host_ip;
            let wsIP;
            if (data.host_ip.includes('https')) {
                wsIP = `wss://${data.host_ip.replace("https://", "")}`;
            } else if (data.host_ip.includes('http')) {
                wsIP = `wss://${data.host_ip.replace("http://", "")}`;
            } else {
                wsIP = `wss://${data.host_ip}`;
            }
            if (hostIP[hostIP.length - 1] === '/') {
                hostIP = hostIP.slice(0, -1);
            }
            if (wsIP[wsIP.length - 1] === '/') {
                wsIP = wsIP.slice(0, -1);
            }

            fetch(`${hostIP}/api/health_check`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(res => {
                    API_URL = hostIP
                    WS = `${wsIP}/stream`
                    HOST = hostIP;

                    console.log({ WS });
                    console.log({ HOST });
                    console.log({ API_URL });
                    resolve(res)
                })
                .catch(err => reject(err))

        } else {
            fetch(process.env.NODE_ENV === 'production' ? `https://${data.host_ip}:3005/api/health_check` : `http://${data.host_ip}:3005/api/health_check`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(res => {
                    API_URL = process.env.NODE_ENV === 'production' ? `https://${data.host_ip}:3005` : `http://${data.host_ip}:3005`
                    WS = process.env.NODE_ENV === 'production' ? `wss://${data.host_ip}:5005` : `ws://${data.host_ip}:5005`
                    HOST = data.host_ip;
                    resolve(res)
                })
                .catch(err => reject(err))
        }

    })

}
export const setToken = (token) => {
    jwtToken = token;
}
export const setUserId = (id) => {
    userId = id;
}

export default AppContextProvider;
